"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    tooltipClassNames: function() {
        return tooltipClassNames;
    },
    useTooltipStyles_unstable: function() {
        return useTooltipStyles_unstable;
    }
});
const _react = require("@griffel/react");
const tooltipClassNames = {
    content: 'fui-Tooltip__content'
};
/**
 * Styles for the tooltip
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "fjseox",
        B7ck84d: "f1ewtqcl",
        B2u0y6b: "f132xexn",
        Bceei9c: "f158kwzp",
        Bahqtrf: "fk6fouc",
        Be2twd7: "fy9rknc",
        Bg96gwp: "fwrc4pm",
        Btd35i7: "fokg9q4",
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "ft85np5",
        Bgfg5da: 0,
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        B4g9neb: 0,
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        u1mtju: 0,
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        i8vvqc: 0,
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        irswps: "f9ggezi",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1bzqsji",
        De3pzq: "fxugw4r",
        sj55zd: "f19n0e5",
        Bhu2qc9: "fxeb0a7"
    },
    visible: {
        mc9l5x: "ftgm304"
    },
    inverted: {
        De3pzq: "fg3r6xk",
        sj55zd: "fonrgv7"
    },
    arrow: {
        qhf8xq: "f1euv43f",
        De3pzq: "f1u2r49w",
        Bcdw1i0: "fd7fpy0",
        Bj3rh1h: "f1bsuimh",
        a9b677: "f1ekdpwm",
        Bqenvij: "f83vc9z",
        Ftih45: "f1wl9k8s",
        B1puzpu: "f1wkw4r9",
        Brfgrao: "f1j7ml58",
        Bcvre1j: "fyl8oag",
        Ccq8qp: "frdoeuz",
        Baz25je: "fb81m9q",
        cmx5o7: "f1ljr5q2",
        Bk5zm6e: 0,
        m598lv: 0,
        B4f6apu: 0,
        eqrjj: "f15tymiq",
        Bqjgrrk: 0,
        qa3bma: 0,
        y0oebl: 0,
        Bcgcnre: "fi8wnwo",
        Budzafs: [
            "f9e5op9",
            "f112wvtl"
        ],
        Hv9wc6: "f16cagkn",
        hl6cv3: "f1773hnp",
        c8svkw: "fw7o64x",
        yayu3t: "f1v7783n",
        nr3p0k: "f1f0d6v",
        rhl9o9: "fh2hsk5",
        wiz9v7: "f1gj3y7g",
        B6q6orb: "f11yvu4",
        ndpsmx: "f17lejdj"
    }
}, {
    d: [
        ".fjseox{display:none;}",
        ".f1ewtqcl{box-sizing:border-box;}",
        ".f132xexn{max-width:240px;}",
        ".f158kwzp{cursor:default;}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".fwrc4pm{line-height:var(--lineHeightBase200);}",
        ".fokg9q4{overflow-wrap:break-word;}",
        [
            ".ft85np5{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ],
        [
            ".f9ggezi{border:1px solid var(--colorTransparentStroke);}",
            {
                p: -2
            }
        ],
        [
            ".f1bzqsji{padding:4px 11px 6px 11px;}",
            {
                p: -1
            }
        ],
        ".fxugw4r{background-color:var(--colorNeutralBackground1);}",
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".fxeb0a7{filter:drop-shadow(0 0 2px var(--colorNeutralShadowAmbient)) drop-shadow(0 4px 8px var(--colorNeutralShadowKey));}",
        ".ftgm304{display:block;}",
        ".fg3r6xk{background-color:var(--colorNeutralBackgroundStatic);}",
        ".fonrgv7{color:var(--colorNeutralForegroundStaticInverted);}",
        ".f1euv43f{position:absolute;}",
        ".f1u2r49w{background-color:inherit;}",
        ".fd7fpy0{visibility:hidden;}",
        ".f1bsuimh{z-index:-1;}",
        ".f1ekdpwm{width:8.484px;}",
        ".f83vc9z{height:8.484px;}",
        ".f1wl9k8s::before{content:\"\";}",
        ".f1wkw4r9::before{visibility:visible;}",
        ".f1j7ml58::before{position:absolute;}",
        ".fyl8oag::before{box-sizing:border-box;}",
        ".frdoeuz::before{width:inherit;}",
        ".fb81m9q::before{height:inherit;}",
        ".f1ljr5q2::before{background-color:inherit;}",
        [
            ".f15tymiq::before{border-right:1px solid var(--colorTransparentStroke);}",
            {
                p: -1
            }
        ],
        [
            ".fi8wnwo::before{border-bottom:1px solid var(--colorTransparentStroke);}",
            {
                p: -1
            }
        ],
        ".f9e5op9::before{border-bottom-right-radius:var(--borderRadiusSmall);}",
        ".f112wvtl::before{border-bottom-left-radius:var(--borderRadiusSmall);}",
        ".f16cagkn::before{transform:rotate(var(--fui-positioning-angle)) translate(0, 50%) rotate(45deg);}",
        "[data-popper-placement^=\"top\"] .f1773hnp{bottom:-1px;}",
        "[data-popper-placement^=\"top\"] .fw7o64x{--fui-positioning-angle:0;}",
        "[data-popper-placement^=\"right\"] .f1v7783n{left:-1px;}",
        "[data-popper-placement^=\"right\"] .f1f0d6v{--fui-positioning-angle:90deg;}",
        "[data-popper-placement^=\"bottom\"] .fh2hsk5{top:-1px;}",
        "[data-popper-placement^=\"bottom\"] .f1gj3y7g{--fui-positioning-angle:180deg;}",
        "[data-popper-placement^=\"left\"] .f11yvu4{right:-1px;}",
        "[data-popper-placement^=\"left\"] .f17lejdj{--fui-positioning-angle:270deg;}"
    ]
});
const useTooltipStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.content.className = (0, _react.mergeClasses)(tooltipClassNames.content, styles.root, state.appearance === 'inverted' && styles.inverted, state.visible && styles.visible, state.content.className);
    state.arrowClassName = styles.arrow;
    return state;
}; //# sourceMappingURL=useTooltipStyles.styles.js.map
